const courseTermsContent = {
  de: {
    title: "AGB & Widerrufsbelehrung",
    body: `ALLGEMEINE GESCHÄFTSBEDINGUNGEN (AGB)

1. GELTUNGSBEREICH
Diese Allgemeinen Geschäftsbedingungen gelten für alle Kurse, Workshops, Meetings, Beratungsleistungen, Bewerbungscoachings sowie sonstigen Dienstleistungen von ALGermanist.
Mit der Buchung eines Kurses, der Nutzung unserer Dienstleistungen oder der Übermittlung von Bewerbungsunterlagen akzeptieren Nutzer diese Bedingungen.

2. ANBIETER
ALGermanist
Inhaber: Mafdi Garas
Schottenstraße
78462 Konstanz
Deutschland
E-Mail: info@algermanist.com
Webseite: https://algermanist.com

3. LEISTUNGEN
ALGermanist bietet insbesondere:
- Online-Deutschkurse
- Workshops
- interkulturelles Training
- Bewerbungscoaching
- Beratung und Unterstützung internationaler Fachkräfte und Auszubildender
- Unterstützung bei Bewerbungsprozessen
- Vermittlungsmöglichkeiten an potenzielle Arbeitgeber oder Ausbildungsbetriebe in Deutschland
Die Kurse finden überwiegend in deutscher Sprache statt.

4. BUCHUNG UND VERTRAGSSCHLUSS
Die Buchung eines Kurses erfolgt über die Webseite oder nach individueller Vereinbarung.
Mit Abschluss der Buchung und erfolgreicher Zahlung kommt ein verbindlicher Vertrag zustande.
Die Teilnahmeplätze sind begrenzt. Eine Buchung ist nur möglich, solange freie Plätze verfügbar sind.

5. PREISE UND ZAHLUNG
Alle Preise verstehen sich in Euro.
Die Zahlung erfolgt über:
- Stripe
- PayPal
- Banküberweisung
Die Zahlung ist vor Kursbeginn vollständig zu leisten.

6. STORNIERUNG UND RÜCKERSTATTUNG
Eine kostenfreie Stornierung ist bis 14 Tage vor Kursbeginn möglich.
Bei einer Stornierung innerhalb von 7 Tagen vor Kursbeginn werden 70 % der Kursgebühren erstattet.
Nach Beginn des Kurses besteht grundsätzlich kein Anspruch auf Rückerstattung.
Diese Stornierungsregelungen gelten ergänzend zum gesetzlichen Widerrufsrecht.

7. UNTERRICHTSSPRACHE
Die Kurse finden überwiegend auf Deutsch statt.
Teilnehmer erklären sich mit dieser Unterrichtsform ausdrücklich einverstanden.

8. TEILNAHMEBEDINGUNGEN
Die Kurse richten sich überwiegend an Erwachsene.
Teilnehmer verpflichten sich zu:
- respektvollem Verhalten
- aktiver Teilnahme
- regelmäßiger Mitarbeit
- Einhaltung der Kursregeln
Rassistische Aussagen, Diskriminierung, Belästigung oder respektloses Verhalten werden nicht toleriert.

9. TECHNISCHE VORAUSSETZUNGEN
Teilnehmer sind selbst verantwortlich für:
- stabile Internetverbindung
- funktionierende Hardware
- Kamera
- Mikrofon
- geeignete Lernumgebung
Technische Probleme auf Seiten der Teilnehmer begründen keinen Anspruch auf Rückerstattung oder Wiederholung von Unterrichtsinhalten.

10. ZOOM UND WHATSAPP
Die Kurse finden online über Zoom statt.
Teilnehmer verpflichten sich:
- ihren echten Namen zu verwenden
- Zugangsdaten nicht weiterzugeben
- keine Aufzeichnungen oder Screenshots anzufertigen
- Zoom-Links nicht an Dritte weiterzugeben
Zur organisatorischen Kommunikation können WhatsApp-Gruppen genutzt werden.
Mit Teilnahme an der Gruppe erklären sich Teilnehmer damit einverstanden, dass andere Gruppenmitglieder ihre Telefonnummer und ihren Profilnamen sehen können.
Die Kommunikation mit dem Dozenten erfolgt ausschließlich über den Gruppenchat.

11. UNTERRICHTSMATERIALIEN UND URHEBERRECHT
Alle Unterrichtsmaterialien, Inhalte, Texte, Videos, Übungen und Konzepte sind urheberrechtlich geschützt.
Es ist insbesondere untersagt:
- Unterricht aufzuzeichnen
- Screenshots anzufertigen
- Inhalte weiterzugeben
- Materialien zu verkaufen oder zu veröffentlichen
- Zugangsdaten oder Zoom-Links weiterzugeben

12. KRANKHEIT UND FEHLZEITEN
Teilnehmer sind verpflichtet, Fehlzeiten möglichst frühzeitig mitzuteilen.
Verpasste Inhalte müssen eigenständig nachgeholt werden.
Der Dozent ist nicht verpflichtet, Unterrichtsinhalte individuell zu wiederholen.

13. AUSFALL VON UNTERRICHT
Sollte ein Unterrichtstermin aufgrund organisatorischer Gründe, technischer Probleme oder Krankheit des Dozenten ausfallen, wird der Termin nachgeholt oder der Kurs entsprechend verlängert.
Weitergehende Ansprüche bestehen nicht.

14. VERMITTLUNG UND BEWERBUNGEN
ALGermanist bietet Unterstützung, Beratung und Vermittlungsmöglichkeiten für internationale Fachkräfte und Auszubildende an.
Interessenten können insbesondere folgende Unterlagen übermitteln:
- Lebenslauf
- Motivationsschreiben
- Sprachzertifikate
- Zeugnisse
- weitere Bewerbungsunterlagen
- Passfoto (falls erforderlich)
Die Unterlagen können an potenzielle Arbeitgeber oder Ausbildungsbetriebe in Deutschland weitergeleitet werden.
Es besteht jedoch kein Anspruch auf:
- erfolgreiche Vermittlung
- Arbeitsstelle
- Ausbildungsplatz
- Visum
- Aufenthaltstitel
- Vorstellungsgespräch
- oder Einstellung
Die Entscheidung über Bewerbungen liegt ausschließlich bei den jeweiligen Arbeitgebern, Unternehmen oder Institutionen.
Nach Weiterleitung der Unterlagen übernimmt ALGermanist keine Verantwortung für die weitere Datenverarbeitung durch die jeweiligen Arbeitgeber.

15. HAFTUNG
ALGermanist haftet nur bei Vorsatz und grober Fahrlässigkeit sowie im Rahmen zwingender gesetzlicher Vorschriften.
Für technische Ausfälle, Internetprobleme oder Störungen auf Seiten der Teilnehmer wird keine Haftung übernommen.

16. HÖHERE GEWALT
ALGermanist haftet nicht für Verzögerungen oder Ausfälle aufgrund höherer Gewalt, insbesondere:
- Naturkatastrophen
- Stromausfälle
- Internetausfälle
- behördliche Maßnahmen
- Pandemien
- technische Großstörungen
- oder sonstige unvorhersehbare Ereignisse

17. ÄNDERUNGEN
ALGermanist behält sich vor, Inhalte, Termine oder organisatorische Abläufe anzupassen, sofern dies sachlich erforderlich und für Teilnehmer zumutbar ist.

18. SCHLUSSBESTIMMUNGEN
Es gilt das Recht der Bundesrepublik Deutschland.
Sollten einzelne Bestimmungen dieser Bedingungen unwirksam sein oder werden, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.

WIDERRUFSBELEHRUNG

WIDERRUFSRECHT
Verbraucher haben grundsätzlich das Recht, binnen vierzehn Tagen ohne Angabe von Gründen einen Vertrag zu widerrufen.
Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des Vertragsabschlusses.
Um Ihr Widerrufsrecht auszuüben, müssen Sie uns mittels einer eindeutigen Erklärung über Ihren Entschluss informieren.
Der Widerruf ist zu richten an:
ALGermanist
Inhaber: Mafdi Garas
Schottenstraße
78462 Konstanz
Deutschland
E-Mail: info@algermanist.com

FOLGEN DES WIDERRUFS
Wenn Sie diesen Vertrag widerrufen, erstatten wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, unverzüglich und spätestens binnen vierzehn Tagen ab Eingang des Widerrufs.
Für die Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der ursprünglichen Transaktion eingesetzt haben, sofern nichts anderes vereinbart wurde.

VORZEITIGER BEGINN DER DIENSTLEISTUNG
Bei der Buchung von Kursen, Workshops oder sonstigen Dienstleistungen stimmen Teilnehmer ausdrücklich zu, dass ALGermanist bereits vor Ablauf der gesetzlichen Widerrufsfrist mit organisatorischen Maßnahmen, der Kursvorbereitung, der Bereitstellung digitaler Inhalte, der Versendung von Zugangsdaten oder sonstigen vorbereitenden Leistungen beginnen darf.
Teilnehmer bestätigen außerdem, dass ihnen bekannt ist, dass bei bereits begonnenen Leistungen ein angemessener Wertersatz verlangt werden kann und das Widerrufsrecht bei vollständiger Vertragserfüllung erlöschen kann.

AUSSCHLUSS BZW. EINSCHRÄNKUNG DES WIDERRUFSRECHTS
Das Widerrufsrecht kann insbesondere eingeschränkt sein, wenn:
- der Kurs bereits begonnen hat
- digitale Inhalte oder Zugangsdaten bereits bereitgestellt wurden
- organisatorische Leistungen bereits erbracht wurden
- oder die Dienstleistung bereits teilweise ausgeführt wurde`,
  },
  en: {
    title: "Terms & Conditions & Right of Withdrawal",
    body: `GENERAL TERMS AND CONDITIONS

1. SCOPE
These General Terms and Conditions apply to all courses, workshops, meetings, consulting services, application coaching, and other services provided by ALGermanist.
By booking a course, using our services, or submitting application documents, users accept these terms.

2. PROVIDER
ALGermanist
Owner: Mafdi Garas
Schottenstraße
78462 Konstanz
Germany
Email: info@algermanist.com
Website: https://algermanist.com

3. SERVICES
ALGermanist provides in particular:
- online German courses
- workshops
- intercultural training
- application coaching
- consulting and support for international skilled workers and trainees
- support with application processes
- possible placement opportunities with potential employers or training companies in Germany
The courses are mainly held in German.

4. BOOKING AND CONTRACT CONCLUSION
Courses are booked through the website or by individual agreement.
Once the booking is completed and payment is successful, a binding contract is concluded.
Places are limited. Booking is only possible while places are available.

5. PRICES AND PAYMENT
All prices are in euros.
Payment is made through:
- Stripe
- PayPal
- bank transfer
Payment must be made in full before the course starts.

6. CANCELLATION AND REFUND
Free cancellation is possible up to 14 days before the course starts.
For cancellation within 7 days before the course starts, 70% of the course fee will be refunded.
After the course has started, there is generally no right to a refund.
These cancellation rules apply in addition to the statutory right of withdrawal.

7. LANGUAGE OF INSTRUCTION
Courses are mainly held in German.
Participants expressly agree to this form of instruction.

8. PARTICIPATION CONDITIONS
The courses are mainly intended for adults.
Participants undertake to:
- behave respectfully
- participate actively
- cooperate regularly
- comply with the course rules
Racist statements, discrimination, harassment, or disrespectful behavior are not tolerated.

9. TECHNICAL REQUIREMENTS
Participants are responsible for:
- a stable internet connection
- functioning hardware
- camera
- microphone
- a suitable learning environment
Technical problems on the participant's side do not create any right to refund or repetition of lesson content.

10. ZOOM AND WHATSAPP
Courses take place online via Zoom.
Participants undertake to:
- use their real name
- not share access data
- not make recordings or screenshots
- not share Zoom links with third parties
WhatsApp groups may be used for organizational communication.
By joining the group, participants agree that other group members may see their phone number and profile name.
Communication with the teacher takes place exclusively through the group chat.

11. TEACHING MATERIALS AND COPYRIGHT
All teaching materials, content, texts, videos, exercises, and concepts are protected by copyright.
In particular, it is prohibited to:
- record lessons
- take screenshots
- share content
- sell or publish materials
- share access data or Zoom links

12. ILLNESS AND ABSENCES
Participants must report absences as early as possible.
Missed content must be caught up independently.
The teacher is not obliged to repeat lesson content individually.

13. CANCELLATION OF LESSONS
If a lesson is cancelled due to organizational reasons, technical problems, or illness of the teacher, the lesson will be rescheduled or the course will be extended accordingly.
Further claims do not exist.

14. PLACEMENT AND APPLICATIONS
ALGermanist offers support, consulting, and possible placement opportunities for international skilled workers and trainees.
Interested persons may submit documents such as:
- CV
- motivation letter
- language certificates
- certificates
- other application documents
- passport photo if required
The documents may be forwarded to potential employers or training companies in Germany.
However, there is no entitlement to:
- successful placement
- employment
- training position
- visa
- residence permit
- interview
- or hiring
Decisions on applications are made exclusively by the respective employers, companies, or institutions.
After forwarding documents, ALGermanist assumes no responsibility for further data processing by the respective employers.

15. LIABILITY
ALGermanist is liable only in cases of intent and gross negligence and within the scope of mandatory statutory provisions.
No liability is accepted for technical failures, internet problems, or disruptions on the participant's side.

16. FORCE MAJEURE
ALGermanist is not liable for delays or cancellations due to force majeure, in particular:
- natural disasters
- power outages
- internet outages
- official measures
- pandemics
- major technical disruptions
- or other unforeseeable events

17. CHANGES
ALGermanist reserves the right to adapt content, dates, or organizational processes if objectively necessary and reasonable for participants.

18. FINAL PROVISIONS
The law of the Federal Republic of Germany applies.
If individual provisions of these terms are or become invalid, the validity of the remaining provisions remains unaffected.

RIGHT OF WITHDRAWAL

Consumers generally have the right to withdraw from a contract within fourteen days without giving reasons.
The withdrawal period is fourteen days from the day the contract is concluded.
To exercise your right of withdrawal, you must inform us of your decision by means of a clear statement.
The withdrawal must be addressed to:
ALGermanist
Owner: Mafdi Garas
Schottenstraße
78462 Konstanz
Germany
Email: info@algermanist.com

CONSEQUENCES OF WITHDRAWAL
If you withdraw from this contract, we will refund all payments received from you immediately and no later than fourteen days after receiving the withdrawal.
For the refund, we will use the same payment method that you used for the original transaction unless otherwise agreed.

EARLY START OF SERVICE
When booking courses, workshops, or other services, participants expressly agree that ALGermanist may begin organizational measures, course preparation, provision of digital content, sending access data, or other preparatory services before the statutory withdrawal period expires.
Participants also confirm that they are aware that reasonable compensation may be charged for services already started and that the right of withdrawal may expire once the contract has been fully performed.

EXCLUSION OR LIMITATION OF THE RIGHT OF WITHDRAWAL
The right of withdrawal may be limited in particular if:
- the course has already started
- digital content or access data has already been provided
- organizational services have already been performed
- or the service has already been partially performed`,
  },
  ar: {
    title: "الشروط والأحكام وحق التراجع",
    body: `الشروط والأحكام العامة

1. نطاق التطبيق
تنطبق هذه الشروط على جميع الدورات وورش العمل والاجتماعات وخدمات الاستشارة والتوجيه المهني والخدمات الأخرى المقدمة من ALGermanist.
وبمجرد حجز دورة أو استخدام الخدمات أو إرسال مستندات التقديم، يوافق المستخدم على هذه الشروط.

2. مقدم الخدمة
ALGermanist
المالك: Mafdi Garas
Schottenstraße
78462 Konstanz
Deutschland
البريد الإلكتروني: info@algermanist.com
الموقع الإلكتروني: https://algermanist.com

3. الخدمات
يقدم ALGermanist بشكل خاص:
- دورات لغة ألمانية أونلاين
- ورش عمل
- تدريب بين الثقافات
- توجيه مهني ومساعدة في التقديم
- دعم ومساعدة المتدربين والمهنيين الدوليين
- المساعدة في عمليات التقديم
- خدمات الوساطة مع جهات العمل أو التدريب المحتملة داخل ألمانيا
وتُقدَّم الدورات بشكل أساسي باللغة الألمانية.

4. الحجز وإبرام العقد
يتم حجز الدورات عبر الموقع الإلكتروني أو باتفاق فردي.
وبمجرد إتمام الحجز والدفع بنجاح يصبح العقد ملزمًا.
عدد الأماكن محدود والحجز متاح فقط عند توفر أماكن.

5. الأسعار والدفع
جميع الأسعار باليورو.
تتم عمليات الدفع عبر:
- Stripe
- PayPal
- التحويل البنكي
ويجب دفع الرسوم كاملة قبل بدء الدورة.

6. الإلغاء واسترداد الرسوم
يمكن الإلغاء مجانًا حتى 14 يومًا قبل بدء الدورة.
في حالة الإلغاء خلال 7 أيام قبل بدء الدورة يتم استرداد 70٪ من الرسوم.
بعد بدء الدورة لا يوجد أي حق في استرداد الرسوم.
وتطبق هذه القواعد بالإضافة إلى حق التراجع القانوني.

7. لغة التدريس
تُقدَّم الدورات بشكل أساسي باللغة الألمانية.
ويوافق المشاركون صراحةً على ذلك.

8. شروط المشاركة
الدورات موجهة بشكل أساسي للبالغين.
ويلتزم المشاركون بـ:
- الاحترام المتبادل
- المشاركة الفعالة
- الالتزام المنتظم
- احترام قواعد الدورة
ولا يتم التسامح مع العنصرية أو التمييز أو التحرش أو أي سلوك غير محترم.

9. المتطلبات التقنية
المشارك مسؤول عن:
- توفر إنترنت مستقر
- جهاز مناسب
- كاميرا
- ميكروفون
- بيئة مناسبة للتعلم
ولا تؤدي المشاكل التقنية من جهة المشارك إلى أي حق في استرداد الرسوم أو إعادة شرح المحتوى.

10. Zoom و WhatsApp
تتم الدورات عبر Zoom.
ويلتزم المشاركون بـ:
- استخدام الاسم الحقيقي
- عدم مشاركة بيانات الدخول
- عدم تسجيل الدروس أو أخذ Screenshots
- عدم مشاركة روابط Zoom مع الآخرين
وقد يتم استخدام مجموعات WhatsApp للتواصل التنظيمي.
وبالانضمام للمجموعة يوافق المشارك على إمكانية ظهور رقم هاتفه واسمه لباقي المشاركين.
ويتم التواصل مع المدرس فقط عبر الجروب.

11. المواد التعليمية وحقوق النشر
جميع المواد التعليمية والمحتويات والنصوص والفيديوهات والتمارين والمفاهيم التعليمية محمية بحقوق النشر.
ويُمنع بشكل خاص:
- تسجيل الحصص
- أخذ Screenshots
- مشاركة المحتوى
- بيع أو نشر المواد
- مشاركة روابط Zoom أو بيانات الدخول

12. المرض والغياب
يجب على المشارك إبلاغ الإدارة أو المدرس بأقرب وقت ممكن في حالة الغياب.
ويجب تعويض المحتوى الفائت بشكل ذاتي.
ولا يلتزم المدرس بإعادة الشرح بشكل فردي.

13. إلغاء أو تأجيل الحصص
في حال إلغاء الحصة بسبب ظروف تنظيمية أو تقنية أو مرض المدرس، يتم تعويض الموعد أو تمديد الدورة وفقًا لذلك.
ولا توجد أي مطالبات إضافية.

14. التوظيف والوساطة
يقدم ALGermanist خدمات دعم واستشارة ومساعدة في التوظيف للمهنيين والمتدربين الدوليين.
ويمكن للمتقدمين إرسال:
- السيرة الذاتية
- خطاب الدافع
- شهادات اللغة
- الشهادات الدراسية
- مستندات إضافية
- صورة شخصية عند الحاجة
وقد يتم إرسال هذه المستندات إلى أصحاب عمل أو جهات تدريب محتملة داخل ألمانيا.
ولكن لا يوجد أي ضمان للحصول على:
- وظيفة
- تدريب مهني
- تأشيرة
- إقامة
- مقابلة عمل
- أو قبول من جهة عمل
وتبقى قرارات التوظيف بيد الشركات والمؤسسات المعنية فقط.
وبعد إرسال البيانات إلى جهة العمل لا يتحمل ALGermanist أي مسؤولية عن طريقة معالجة البيانات لدى جهة العمل.

15. المسؤولية
يتحمل ALGermanist المسؤولية فقط في حالات القصد أو الإهمال الجسيم ووفقًا للقانون الإلزامي.
ولا يتحمل أي مسؤولية عن الأعطال التقنية أو مشاكل الإنترنت من جهة المشاركين.

16. القوة القاهرة
لا يتحمل ALGermanist أي مسؤولية عن التأخير أو التوقف الناتج عن ظروف خارجة عن الإرادة مثل:
- الكوارث الطبيعية
- انقطاع الكهرباء
- انقطاع الإنترنت
- القرارات الحكومية
- الأوبئة
- الأعطال التقنية الكبيرة
- أو أي أحداث غير متوقعة أخرى

17. التعديلات
يحتفظ ALGermanist بحق تعديل المواعيد أو المحتوى أو الإجراءات التنظيمية عند الحاجة وبشكل معقول.

18. أحكام ختامية
يطبق قانون جمهورية ألمانيا الاتحادية.
وفي حال بطلان أي بند من هذه الشروط تبقى بقية البنود سارية المفعول.

سياسة حق التراجع

حق التراجع
يحق للمستهلك من حيث المبدأ التراجع عن العقد خلال أربعة عشر يومًا دون الحاجة إلى ذكر الأسباب.
مدة التراجع هي أربعة عشر يومًا من تاريخ إبرام العقد.
ولممارسة حق التراجع يجب إرسال إشعار واضح إلى:
ALGermanist
المالك: Mafdi Garas
Schottenstraße
78462 Konstanz
Deutschland
البريد الإلكتروني: info@algermanist.com

آثار التراجع
في حال التراجع عن العقد، يتم رد جميع المدفوعات المستلمة خلال مدة لا تتجاوز أربعة عشر يومًا من تاريخ استلام طلب التراجع.
وسيتم استخدام نفس وسيلة الدفع الأصلية ما لم يتم الاتفاق على غير ذلك.

البدء المبكر في تقديم الخدمة
عند حجز دورة أو ورشة عمل أو أي خدمة أخرى، يوافق المشارك صراحةً على أن يبدأ ALGermanist في اتخاذ الإجراءات التنظيمية وتحضير الدورة وإرسال بيانات الدخول أو تقديم الخدمات الرقمية قبل انتهاء مدة التراجع القانونية.
كما يقر المشارك بأنه على علم بأنه قد يتم احتساب تعويض مناسب عن الخدمات التي بدأت بالفعل، وأن حق التراجع قد ينتهي عند اكتمال تنفيذ الخدمة بالكامل.

استثناءات أو قيود حق التراجع
قد يتم تقييد حق التراجع في الحالات التالية:
- إذا بدأت الدورة بالفعل
- أو تم إرسال محتوى رقمي أو بيانات الدخول
- أو تم تنفيذ خدمات تنظيمية أو تحضيرية
- أو تم تنفيذ جزء من الخدمة بالفعل`,
  },
};

export default courseTermsContent;
